import React from 'react';
import { useKeyboardDetector, useSafeArea } from '../utils/useKeyboardDetector';
/**
 * 应用容器组件
 * 负责处理全局布局、键盘检测和安全区域适配
 */
export const AppContainer = ({ children }) => {
    const { isKeyboardVisible } = useKeyboardDetector();
    const safeArea = useSafeArea();
    return (React.createElement("div", { className: `App ${isKeyboardVisible ? 'keyboard-visible' : ''}` }, children));
};
export default AppContainer;
